import type Alpine from "alpinejs";

// Identity wrapper for an Alpine `x-data` object literal. Its job is to make
// `this.$watch` / `this.$el` / `this.$refs` / `this.$nextTick` / `this.$dispatch`
// (Alpine's runtime "magics") type-check inside the component's methods, which
// they otherwise don't — a plain object literal's `this` only knows its own
// fields, so every magic access is a TS2339 error.
//
// Trade-off worth knowing: because Alpine components mix data fields and methods
// in ONE object, and the methods reference `this`, TypeScript cannot both infer
// the component type T from this literal AND feed `T & Magics<T>` back in as the
// `this` context — that is circular, so it falls back to `this: any` inside the
// methods. The net effect is that magics resolve and the module compiles, but
// field access inside a component method (`this.count`, `this.mode`) is loosely
// typed. That is acceptable here: this bundle was never type-checked before, so
// nothing is lost, and the high-value checks (imports, exports, factory args,
// external-API calls) all live at module scope and remain fully enforced. To
// tighten a specific component later, give it a dedicated state interface and
// annotate its methods' `this` explicitly.
//
// Zero runtime cost: returns its argument unchanged.
export function alpineData<T>(obj: T & ThisType<T & Alpine.Magics<T>>): T {
  return obj;
}
